import { jsx as _jsx } from "react/jsx-runtime";

function SvgLinkedin() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.6 1A1.6 1.6 0 001 2.6v18.8A1.6 1.6 0 002.6 23h18.8a1.6 1.6 0 001.6-1.6V2.6A1.6 1.6 0 0021.4 1H2.6zm17.086 18.583H16.5V14c0-3.35-3.816-2.854-3.816 0v5.583H9.617V9.173h3.067V10.7C13.5 8.5 19.5 7.5 19.686 13v6.583zm-15.42-.166H7.5V9.333H4.267v10.084zM5.9 7.8a1.9 1.9 0 100-3.8 1.9 1.9 0 000 3.8z",
      fill: "#0A66C2"
    }, void 0)
  }), void 0);
}

export default SvgLinkedin;